import { Typography, Box, Divider } from '@mui/material';
import { colors } from 'src/styles/theme';

export default function InstructionsList({
  title = 'Instructions',
  instructions = [],
  footerText = null,
}) {
  // Check if instructions use the new format with label/description objects
  const isNewFormat =
    instructions.length > 0 && typeof instructions[0] === 'object' && instructions[0].label;

  return (
    <Box>
      <Typography sx={{ fontSize: '16px', fontWeight: 600, lineHeight: '24px', mb: 1 }}>
        {title}
      </Typography>
      {isNewFormat ? (
        <Box component="ul" sx={{ m: 0, p: 0, listStyle: 'none' }}>
          {instructions.map((item, key) => (
            <Typography
              component="li"
              key={key}
              sx={{ fontSize: '14px', lineHeight: '20px', mb: 0.5 }}
            >
              <Box component="span" sx={{ fontWeight: 600 }}>
                {item.label}
              </Box>{' '}
              {item.description}
            </Typography>
          ))}
        </Box>
      ) : (
        <Box component="ol" sx={{ m: 0, p: 0, listStylePosition: 'inside' }}>
          {instructions.map((item, key) => (
            <li key={key}>{item}</li>
          ))}
        </Box>
      )}
      {footerText && (
        <>
          <Divider sx={{ my: 1.5, borderColor: colors.grey[300] }} />
          <Typography sx={{ fontSize: '14px', lineHeight: '20px' }}>{footerText}</Typography>
        </>
      )}
    </Box>
  );
}
